import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useNavigate, useParams } from '@tanstack/react-router';
import { toast } from 'sonner';

const useManageHostInfo = () => {
  const navigate = useNavigate();
  const params = useParams({ from: '/(app)/store-information/basic-stores/host-management/$clubid/$manage-host' });
  const { mutateAsync } = useMutation('manageHostInfo', {
    onSuccess: async (res) => {
      void navigate({
        to: '/store-information/basic-stores/host-management/$clubid',
        params: {
          clubid: params['clubid'],
        },
      });
      await revalidate(['hostDetail', 'clubHosts']);
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
  return { mutateAsync };
};

export default useManageHostInfo;
